import { render } from "./ProjectPwaPage.vue?vue&type=template&id=d37d1298"
import script from "./ProjectPwaPage.vue?vue&type=script&lang=js"
export * from "./ProjectPwaPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__